/**
 * Render a backend `questions` event as a single conversational
 * clarification text bubble. Used by both the drawer single-chart path
 * and the bridge page-stream path so the assistant's clarification UI
 * is consistent regardless of which call surfaced it.
 */
export function formatClarificationQuestionsAsText(args: {
  triggerReason: string;
  questions: ReadonlyArray<{ title?: string }>;
  /** Fallback message when the backend returned neither a reason nor any titles. */
  emptyFallback: string;
}): string {
  const { triggerReason, questions, emptyFallback } = args;
  const titles = questions
    .map((q) => q.title?.trim())
    .filter((t): t is string => Boolean(t));
  const lead = triggerReason.trim();
  if (titles.length === 0) {
    return lead || emptyFallback;
  }
  if (titles.length === 1) {
    const single = titles[0] ?? '';
    if (!lead) {
      return single;
    }
    return lead === single ? lead : `${lead} ${single}`;
  }
  const block = titles.map((t) => `- ${t}`).join('\n');
  return lead ? `${lead}\n\n${block}` : block;
}
